// extracted by mini-css-extract-plugin
export default {"InputField":"InputStyle_InputField__FiKy2"};